module.exports = "/* nothing yet */\r\n"